import { AbstractEntityMapper } from '@pf/shared-services';
import {
    ReplenishmentCreate,
    ReplenishmentDto,
    ReplenishmentRead,
    ReplenishmentSearchParams,
} from '../../entities/replenishment.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { ReplenishmentMetadataMap } from './replenishment.mapping-profile';

@Injectable()
export class ReplenishmentMapper extends AbstractEntityMapper<
    ReplenishmentRead,
    ReplenishmentCreate,
    ReplenishmentDto,
    ReplenishmentSearchParams
> {
    constructor() {
        super(
            ReplenishmentDto,
            PlatformWmsMapper,
            ReplenishmentMetadataMap.symbols
        );
    }
}
